export const DROPDOWN_ROLE_OPTIONS = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Super Admin",
    value: "super_admin",
  },
];
